// extracted by mini-css-extract-plugin
export default {"root":"OHPSkS","image":"pVRFqP","overlay":"xUQD7o","leftCorner":"jsd9or","center":"HJXwdZ","showOverlayOnHover":"FRoIWK","live":"tkMIXY","header":"fxXBgd","currency":"vSMONB"};